import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useSelector } from 'editor/src/store/hooks';

import IconUpload from 'editor/src/component/Icon/IconUpload';

import styles from './index.module.scss';

const ACCEPTED_FONT_TYPES = '.ttf,.otf';

interface Props {
  onFilesSelected: (files: File[]) => void;
}

function FontUploadButton({ onFilesSelected }: Props) {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);
  const fontUploadEnabled = useSelector((state) => state.fonts.fontUploadEnabled);

  const handleClick = useCallback(() => {
    inputRef.current?.click();
  }, []);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const files = Array.from(e.target.files || []);
      if (files.length > 0) {
        onFilesSelected(files);
      }
      if (inputRef.current) {
        inputRef.current.value = '';
      }
    },
    [onFilesSelected],
  );

  if (!fontUploadEnabled) {
    return null;
  }

  return (
    <div className={styles.uploadButton}>
      <button type="button" className={styles.button} onClick={handleClick}>
        <IconUpload />
        <span>{t('txt_editor_font_upload_button')}</span>
      </button>
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPTED_FONT_TYPES}
        multiple
        onChange={handleChange}
        className={styles.hiddenInput}
      />
    </div>
  );
}

export default React.memo(FontUploadButton);
